/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ElementCollectionItemIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ElementCollectionItemIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.5"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 2C11.3112 2 12.5231 2.294 13.4248 2.79492C14.3096 3.28647 15 4.04561 15 5V11C15 11.9544 14.3096 12.7135 13.4248 13.2051C12.5231 13.706 11.3112 14 10 14C8.68879 14 7.4769 13.706 6.5752 13.2051C5.69042 12.7135 5 11.9544 5 11V5C5 4.04561 5.69042 3.28647 6.5752 2.79492C7.4769 2.294 8.68879 2 10 2ZM14 6.82129C13.8224 6.96255 13.6292 7.0915 13.4248 7.20508C12.5231 7.706 11.3112 8 10 8C8.68879 8 7.4769 7.706 6.5752 7.20508C6.37076 7.0915 6.17756 6.96255 6 6.82129V11C6 11.4263 6.31669 11.9178 7.06055 12.3311C7.78751 12.7349 8.82597 13 10 13C11.174 13 12.2125 12.7349 12.9395 12.3311C13.6833 11.9178 14 11.4263 14 11V6.82129ZM10 3C8.82597 3 7.78751 3.26508 7.06055 3.66895C6.31669 4.08222 6 4.57369 6 5C6 5.42631 6.31669 5.91778 7.06055 6.33105C7.78751 6.73492 8.82597 7 10 7C11.174 7 12.2125 6.73492 12.9395 6.33105C13.6833 5.91778 14 5.42631 14 5C14 4.57369 13.6833 4.08222 12.9395 3.66895C12.2125 3.26508 11.174 3 10 3Z"
            fill="currentColor"
          />
          <g>
            <path d="M3 8H0V9H3V8Z" fill="currentColor" />
            <path
              d="M10 10C8.82597 10 7.7878 9.73456 7.06084 9.33069C6.31694 8.91741 6 8.42632 6 8H5C5 8.95439 5.69042 9.7133 6.5752 10.2048C7.47691 10.7058 8.68875 11 10 11C11.3113 11 12.5231 10.7058 13.4248 10.2048C14.3096 9.7133 15 8.95439 15 8H14C14 8.42632 13.6831 8.91741 12.9392 9.33069C12.2122 9.73456 11.174 10 10 10Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ElementCollectionItemIcon.tags = [
  'collection',
  'collection item',
  'data',
  'database',
  'minus',
  'remove',
  'delete',
];

ElementCollectionItemIcon.category = 'Navigator';

ElementCollectionItemIcon.iconSize = 16;
